import Flex from 'UIKit/Box/Flex'
import IconButton from 'UIKit/Button/IconButton'
import { InhouseGameDetails } from 'config/types/game'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import useModal from 'hooks/useModal'
import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import { useResponsiveLayout } from 'state/app/hooks'
import { useAuth } from 'state/auth/hooks'
import styled from 'styled-components'
import AirdropBoxStorageDesktop from 'views/GameDetails/AirdropAnimation/AirdropBoxStorageDesktop'
import TournamentDetailsOfGame from 'views/GameDetails/TournamentDetailsOfGame'
import FavoriteGameButton from 'views/Games/components/FavoriteGameButton'
import ShareGameButton from 'views/Games/components/ShareGameButton'
import { GameInHouseConfig } from '../config/types'
import FairnessModal from './FairnessModal'
import GraphicSettings from './GraphicSettings'

const GameInHouseBottom: React.FC<{ game: InhouseGameDetails; settings: GameInHouseConfig }> = ({ game, settings }) => {
  const [onFairness] = useModal(FairnessModal)

  const responsive = useResponsiveLayout()
  const { isMobile, isDesktop } = useMatchBreakpoints()
  const { isSigned } = useAuth()

  return (
    <Flex
      height="65px"
      mt={responsive(['6px', '6px', '0px'])}
      position="absolute"
      bottom="0px"
      left="0px"
      justifyContent="flex-start"
      alignItems="center"
      flexWrap={responsive(['wrap', 'wrap', 'nowrap'])}
      width="100%"
      px={['12px', '', '20px']}
    >
      <RowMiddle>
        <GraphicSettings {...settings} game={game} size="28px" />
        <FavoriteGameButton game={game} ml="16px" size="28px" />
        <ShareGameButton game={game} ml="16px" size="28px" />
      </RowMiddle>

      <Flex alignItems="center" justifyContent="flex-end" flex={1}>
        {isDesktop && <TournamentDetailsOfGame height="49px" mr="20px" />}
        {isSigned && !isMobile && <AirdropBoxStorageDesktop />}
        <StyledFairness onClick={() => onFairness({ game })}>
          <Trans>Fairness</Trans>
        </StyledFairness>
      </Flex>
    </Flex>
  )
}

const StyledFairness = styled(IconButton)`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textSubtle};
  padding-left: 24px;
  position: relative;

  &:before {
    content: '|';
    position: absolute;
    left: 6px;
    top: 0;
    color: ${({ theme }) => theme.colors.textSubtle};
  }

  &:hover {
    color: ${({ theme: { colors } }) => colors.text};
  }
`

export default GameInHouseBottom
